import { useSalonManagerContext } from '@admin/components/templates/SalonManager/context'
import Grid from '@blocks/Grid'
import { desktop } from '@styles/mixins'
import { colors } from '@styles/vars'
import React from 'react'
import styled, { css } from 'styled-components'
import Filters from './components/Filters/SalonFilters'
import SalonSort from './components/Sort/SalonSort'
import useGalleryArchive from './hooks/useGalleryArchive'

export default function SalonGalleryPage() {
    const { salon } = useSalonManagerContext()
    const participations = salon.api.participations.index.use(`admin:salon:${salon.state.id}:participations`)
    const archive = useGalleryArchive(participations.data)

    return (
        <Grid gap="20px">
            <Header>
                <Filters sections={salon.state.sections} archive={archive} />
                <SalonSort archive={archive} />
            </Header>
            <Grid gap="10px">
                {archive.element}
            </Grid>
        </Grid>
    )
}

// STYLES
const Header = styled.div`
    background: ${colors.white};
    border: 1px solid ${colors.border};
    padding: 15px;
    border-radius: 10px;

    & > *:not(:last-child) {
        margin-bottom: 20px;
    }

    ${desktop(css`
        display: flex;
        justify-content: space-between;
        align-items: center;

        & > *:not(:last-child) {
            margin-bottom: 0;
            margin-right: 15px;
        }
    `)}
`